module.exports = __webpack_public_path__ + "media/images/img_Solicitud_Formularios-981ed1a6.jpg";